import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import NormativesList from './NormativesList';
import { icon } from 'leaflet';

//redux

const Normatives = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Normativa', icon: 'icon-book-minus' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Normativas' links={breadcrumbLinks} icon={'icon-file-text'}/>
					<NormativesList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Normatives;
